<script setup>
import { computed, getCurrentInstance } from 'vue';
import Button from "./Button.vue";

const props = defineProps({
    pageContentId: Number
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const pageContentLinkItem = computed(() => {
    return store.state.pageContentData.items.find(o => o.id === props.pageContentId);
});

const contentItems = computed(() => {
    if (pageContentLinkItem.value) {
        return store.state.pageContentData.items.filter(
            o => o.contentId === pageContentLinkItem.value.contentId
        );
    }
    return [];
});

const count = computed(() => {
    const total = contentItems.value.length;
    // Only show the count if the content is used in more than one place
    return total > 1 ? total : 0;
});

// --- Methods ---

const unlinkContent = () => {
    store.dispatch('request/post', {
            url: 'api/unlink-content',
            postData: {
                pageContentId: props.pageContentId
            }
        })
        .then(() => {
            /**
             * Refresh the page content items. This is crucial because unlinking
             * generates a new contentId for this specific pageContentId.
             */
            return store.dispatch('pageContentData/init');
        });
};
</script>

<template>
    <div v-if="count" class="dropdown">
        <Button
            class="btn-sm border"
            title="Usage count"
            data-bs-toggle="dropdown"
        >
            {{ count }}
        </Button>

        <div class="dropdown-menu dropdown-menu-end p-1" @click.stop>
            <Button class="btn-sm w-100 text-start" @click.native="unlinkContent">
                Unlink content
            </Button>
        </div>
    </div>
</template>

<style scoped>
/* Bootstrap dropdowns inside small containers sometimes need
   specific z-index handling, but standard styles apply here. */
</style>